<template>
  <base-form v-if="source" :do="save" :v-errors="error" class="flex flex-col">
    <div class="modal-body content">
      <text-input class="w-full"
        v-model="source.name"
        label="Geselecteerd"
        name="name"
        type="text"
        :disabled="true"
      ></text-input>

      <autocomplete-input
        label="Bron"
        name="correction"
        v-model="correction"
        v-validate="'required'"
        :items="sources"
        :isAsync="true"
        :required="true"
        :error="errors.first('Bron')"
        @changed="onTextChanged"
      ></autocomplete-input>

      <span class="text-grey-darkest text-xs italic">
        Selecteer een bron of maak een nieuwe correctie aan
      </span>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-tertiary btn-sm" @click="close">Cancel</button>
      <button type="submit" class="btn btn-primary btn-sm">Opslaan</button>
    </div>
  </base-form>
</template>

<script>
import SourceService from '@/services/source';
import BaseForm from '@/components/globals/BaseForm';
import TextInput from '@/components/inputs/Text';
import AutocompleteInput from '@/components/inputs/Autocomplete';

import { mapMutations, mapState } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
  name: 'CorrectionModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    TextInput,
    AutocompleteInput
  },
  data() {
    return {
      correction: null,
      sources: [],
      retry: true
    };
  },
  computed: {
    ...mapState({
      source: state => state.modal.items,
      error: state => state.source.error
    })
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL
    }),
    async onTextChanged(value) {
      if (value.length < 3) return (this.retry = true);

      if (!this.sources.length && !this.retry) return (this.sources = []);

      const { data: response } = await SourceService.search(value);
      this.sources = response.data.map(source => {
        return source.name;
      });

      if (!this.sources.length) {
        this.retry = false;
      }
    },
    close: function() {
      this.$validator.reset();
      this.hide();
    },
    async save() {
      await this.$store.dispatch('source/save', {
        wrong: this.source.name,
        correction: this.correction
      });

      if (this.error) return;
      this.close();
    }
  }
};
</script>

<style>
.modal-container .modal-body {
  overflow: unset;
}
</style>
